import React from 'react';

interface ResultsHeaderProps {
  currentRole: number;
  approveButtonLabel: string;
  isLoaded: boolean;
  onApproveDisapprove: () => void; // Pass the handler as a prop
  onPlacesToAnnounce: () => void; // Pass the handler as a prop
  performanceType: string;
  performanceSubType: string;
  existingPlacetoannounceCount: number;
}

const ResultsHeader: React.FC<ResultsHeaderProps> = ({ currentRole, approveButtonLabel, isLoaded , onApproveDisapprove, onPlacesToAnnounce, performanceType, performanceSubType, existingPlacetoannounceCount }) => {
  void isLoaded;
  //console.log("existingPlacetoannounceCount:",existingPlacetoannounceCount);

  return (
    <div className="list-header">
      <div className="entry-number">
        <h5 className="performance-list-text">Entry</h5>
      </div>
      <div className="program-or-performer">
        <h5 className="performance-list-text">Program/Performer</h5>
      </div>
      <div className="routine-name">
        <h5 className="performance-list-text">Routine</h5>
      </div>
      <div className="total-score">
        <h5 className="performance-list-text">Total</h5>
      </div>
      <div className="action-buttons">
        {(currentRole === 1 || currentRole === 8) && (
          <div>
          <button
            className={approveButtonLabel === "Disapprove All" ? "disapprove-button w-button" : "approve-button w-button"}
            onClick={() => onApproveDisapprove()} // Call the parent's handler
          >
            {approveButtonLabel}
          </button>
          {(performanceType === "sds" || (performanceType === "twd" && performanceSubType === "showcase")) && approveButtonLabel === "Approve All" && (
            <button
              className={`${approveButtonLabel === "Approve All" ? "approve-button w-button" : "disapprove-button w-button"} places_to_announce_btn`}
              style={{marginLeft:"20px"}}
              onClick={() => onPlacesToAnnounce()} // Call the parent's handler
            >
              Places to Announce {existingPlacetoannounceCount}
            </button>
          )}
        </div>
        )}

      </div>
    </div>
  );
};

export default ResultsHeader;
